<template>
  <b-navbar fixed="top" toggleable="md" type="dark" class="d-flex p-0 m-0">
    <b-container class="m-auto pl-1 pr-1">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand href="/" class="p-0">
        <img src="../assets/sci4tech.jpg" width="35px">
        Sci4Tech
      </b-navbar-brand>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'navigation',
  methods: {},
  computed: {}
}
</script>

<style>
.navbar {
  border: 1.5px solid black;
  background-color: black !important;
  font-family: "Helvetica Neue";
}

.bg-dark {
    background-color: black !important;
}

.navbar-brand {
  align-items: center;
  display: inline-block;
  /* font-size: 18px; */
  font-weight: bold;
}
</style>
